export default {
  meta: {
    title: '历史拓店任务'
  }
};
